import { ToolTye } from '@/components/Note/utils';
import React, { useMemo } from 'react';
import { useIntl } from 'umi';
import s from './index.less';
import Icon from '@/components/Icon';
import classNames from 'classnames';
import { ToolIconMap, ToolTitleMap } from '../Shape';
import SelectBox from '../select-box';
import { PEN_WIDTH } from '../../types';
import PenIcon from '../PenIcon';

export type ShapeSelectValue = {
  type: ToolTye;
  pen_width?: PEN_WIDTH;
};
interface ShapeSelectProps {
  value: ShapeSelectValue;
  onChange: (value: ShapeSelectValue) => void;
}

const ShapeSelect: React.FC<ShapeSelectProps> = (props) => {
  const { value, onChange } = props;
  const { formatMessage } = useIntl();
  const onSelectWidth = (pen_width: PEN_WIDTH) => {
    onChange({ type: value.type, pen_width: pen_width });
  };
  const change = (type: ToolTye) => {
    onChange({ type, pen_width: value.pen_width });
  };
  return (
    <SelectBox
      topTitle={formatMessage({ id: 'graph' })}
      bottomTitle={formatMessage({ id: 'lineWidth' })}
      TopComponent={
        <>
          <PenIcon
            title={ToolTitleMap[ToolTye.LINE_ARROW]}
            name={ToolIconMap[ToolTye.LINE_ARROW]}
            className={classNames(s.item, value.type === ToolTye.LINE_ARROW ? s.active : '')}
            onClick={() => change(ToolTye.LINE_ARROW)}
          ></PenIcon>

          <PenIcon
            title={ToolTitleMap[ToolTye.LINE]}
            name={ToolIconMap[ToolTye.LINE]}
            className={classNames(s.item, value.type === ToolTye.LINE ? s.active : '')}
            onClick={() => change(ToolTye.LINE)}
          ></PenIcon>

          <PenIcon
            title={ToolTitleMap[ToolTye.RECT]}
            name={ToolIconMap[ToolTye.RECT]}
            className={classNames(s.item, value.type === ToolTye.RECT ? s.active : '')}
            onClick={() => change(ToolTye.RECT)}
          ></PenIcon>

          <PenIcon
            title={ToolTitleMap[ToolTye.ELLIPSE]}
            name={ToolIconMap[ToolTye.ELLIPSE]}
            className={classNames(s.item, value.type === ToolTye.ELLIPSE ? s.active : '')}
            onClick={() => change(ToolTye.ELLIPSE)}
          ></PenIcon>
        </>
      }
      BottomComponent={
        <>
          <PenIcon
            name="icon-a-Vector513Stroke"
            onClick={() => onSelectWidth(PEN_WIDTH.WIDTH_ULTRA_FINE)}
            className={classNames(
              s.item,
              value.pen_width === PEN_WIDTH.WIDTH_ULTRA_FINE ? s.active : ''
            )}
          ></PenIcon>
          <PenIcon
            name="icon-a-Vector514Stroke"
            onClick={() => onSelectWidth(PEN_WIDTH.WIDTH_STANDARD)}
            className={classNames(
              s.item,
              value.pen_width === PEN_WIDTH.WIDTH_STANDARD ? s.active : ''
            )}
          ></PenIcon>
          <PenIcon
            name="icon-a-Vector515Stroke"
            onClick={() => onSelectWidth(PEN_WIDTH.WIDTH_BOLD)}
            className={classNames(s.item, value.pen_width === PEN_WIDTH.WIDTH_BOLD ? s.active : '')}
          ></PenIcon>

          <PenIcon
            name="icon-a-Vector516Stroke"
            onClick={() => onSelectWidth(PEN_WIDTH.WIDTH_ULTRA_BOLD)}
            className={classNames(
              s.item,
              value.pen_width === PEN_WIDTH.WIDTH_ULTRA_BOLD ? s.active : ''
            )}
          ></PenIcon>
        </>
      }
    ></SelectBox>
  );
};

export default ShapeSelect;
